import { LOG_BUFFER_SIZE } from '../config.js';

const buffer = [];
const subscribers = new Set();

export function log(level, msg, meta = {}) {
  const entry = { ts: new Date().toISOString(), level, msg, meta };
  buffer.push(entry);
  if (buffer.length > LOG_BUFFER_SIZE) buffer.shift();
  for (const fn of subscribers) {
    try {
      fn(entry);
    } catch (_e) {
      /* swallow */
    }
  }
  // Also forward to console for dev tools
  const consoleFn =
    level === 'error' ? console.error : level === 'warn' ? console.warn : console.log;
  consoleFn(`[${entry.ts}] ${level.toUpperCase()} ${msg}`, meta);
}

export function logInfo(msg, meta) {
  log('info', msg, meta);
}
export function logWarn(msg, meta) {
  log('warn', msg, meta);
}
export function logError(msg, meta) {
  log('error', msg, meta);
}

export function getLogs() {
  return buffer.slice();
}

export function subscribeLogs(fn) {
  subscribers.add(fn);
  return () => subscribers.delete(fn);
}

export function clearLogs() {
  buffer.length = 0;
}
